/**
 * Chrome-family browsers (Chrome, Brave, Edge) have two ways of laying a saved-address list over Google's suggestions
 * (#283), and no autocomplete value stops both:
 * - The address list ignores autocomplete="off" on a field it takes for an address, which it does from the field's
 *   text: a placeholder or label saying "address" is enough. So the text on a Places search box must not say "address".
 * - Suggestions while typing (Chromium 156+) match what's typed against saved addresses on any field, unless it is
 *   autocomplete="off". An unrecognised value doesn't stop them.
 */
export const NO_BROWSER_AUTOFILL = 'off';

/** Keeps autocomplete="off" on a Places search box, whatever else sets it. Call it after constructing the Autocomplete. */
export function blockBrowserAutofill(input: HTMLInputElement): void {
  const apply = () => {
    if (input.getAttribute('autocomplete') !== NO_BROWSER_AUTOFILL) input.setAttribute('autocomplete', NO_BROWSER_AUTOFILL);
  };
  apply();
  new MutationObserver(apply).observe(input, { attributes: true, attributeFilter: ['autocomplete'] });
}
